export const stats = [
    {
      data: "35K",
      title: "Customers",
    },
    {
      data: "10K+",
      title: "Downloads",
    },
    {
      data: "40+",
      title: "Countries",
    },
    {
      data: "30M+",
      title: "Total revenue",
    },
  ];
  
  export const testimonials = [
    {
      avatar: "https://api.uifaces.co/our-content/donated/xZ4wg2Xj.jpg",
      name: "Martin escobar",
      title: "Customer",
      quote:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc et est hendrerit, porta nunc vitae, gravida justo. Nunc fermentum magna lorem, euismod volutpat arcu volutpat et.",
    },
    {
      avatar: "https://randomuser.me/api/portraits/women/79.jpg",
      name: "Angela stian",
      title: "Customer",
      quote:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout, that the point of using Lorem Ipsum.",
    },
    {
      avatar: "https://randomuser.me/api/portraits/men/86.jpg",
      name: "Karim ahmed",
      title: "Customer",
      quote:
        "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati ",
    },
  ];

  export const team = [
    {
      avatar: "https://robohash.org/Terrill.png?set=set4",
      name: "Emily Rodriguez",
      title: "Coordinator & Full Stack Developer",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesettin industry.",
      linkedin: "www.google.com",
      twitter: "www.google.com",
    },
    {
      avatar:
        "https://robohash.org/Terry.png?set=set4",
      name: "Alexander Schmidt",
      title: "Director",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesettin industry.",
      linkedin: "www.google.com",
      twitter: "www.google.com",
    },
    {
      avatar:
        "https://robohash.org/Sheldon.png?set=set4",
      name: "Sofia Novak",
      title: "Full Stack Developer",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesettin industry.",
      linkedin: "www.google.com",
      twitter: "www.google.com",
    },
    {
      avatar:
        "https://robohash.org/Miles.png?set=set4",
      name: "Javier Fernandez",
      title: "Full Stack Developer",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesettin industry.",
      linkedin: "www.google.com",
      twitter: "www.google.com",
    },
    {
      avatar:
        "https://robohash.org/Mavis.png?set=set4",
      name: "Elena Petrov",
      title: "Full Stack Developer",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesettin industry.",
      linkedin: "www.google.com",
      twitter: "www.google.com",
    },
    {
      avatar:
        "https://robohash.org/Alison.png?set=set4",
      name: "Diego Silva",
      title: "Full Stack Developer",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesettin industry.",
      linkedin: "www.google.com",
      twitter: "www.google.com",
    },
  ];